module.exports = __webpack_public_path__ + "media/customizations/paintedprairie/back-93152c1f0939bce6289cf7bdd3556a06.jpg";